import { DataModel } from "common/models/utility-models/base-model";

export class TerminateInternshipModel extends DataModel {
    override id: any = '';
    // name: any = '';
    // email: any = '';
    internshipTerminatedReason: any = '';
}